import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-account-create-dialog',
  templateUrl: './confirm-account-create-dialog.component.html',
  styleUrls: ['./confirm-account-create-dialog.component.scss']
})
export class ConfirmAccountCreateDialogComponent implements OnInit {

  selectType: string;

  constructor(
    private dialogRef: MatDialogRef<ConfirmAccountCreateDialogComponent>,
    private change: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }

  click(type) {
    this.selectType = type;
    this.change.detectChanges();
    this.dialogRef.close(this.selectType)
  }

  /*close() {
    this.dialogRef.close(this.selectType)
  }*/

}
